


































import ripple from "./ripple.vue";
import scrollbar from "./scrollBar.vue";

import { Component, Watch, Vue, Prop} from "vue-property-decorator";
import { nextTick } from "process";

type dropdownType = "select"|"options";
export interface DropdownInterface{
    type:dropdownType,
    items: DropdownItem[]
}

export interface DropdownItem{
    name:string,
    focus:boolean
    icon?:string,
    style?: string,
    function?: any,
    value?: string,
}

@Component({
    components: {
        ripple,
        scrollbar
    }
})
export default class DropdownMenu extends Vue{

    @Prop({}) hardSet:number;
    @Prop({}) dark:boolean;
    @Prop({}) buttonLike:boolean;
    @Prop({}) dropdownValues:DropdownInterface;
    @Prop({}) selectedItemIndex:number;
    @Prop({}) large:boolean;

    dropdownItemIndex:number = 0;
    dropdownWrapper: HTMLDivElement;
    isVisible:boolean = false;
    selectedRow:number = 0;

    setOption(){

    }

    mounted(){
        this.eventHandlers();
        this.scrollBarInit();
        this.findFocus();
        this.dropdownWrapper = this.$refs.dropdownWrapper as HTMLDivElement;
    }

    findFocus(){
        for(let i=0;i<this.dropdownValues.items.length;i++){
            if(this.dropdownValues.items[i].focus == true){
                this.selectedRow = i;
                break;
            }
        }
    }

    scrollBarInit(){
        nextTick(() => {
            if(!this.isVisible) return;
            (this.$refs.scrollBar as scrollbar).mountScrollable(this.$refs.scrollable as HTMLDivElement);
        })
    }

    eventHandlers(){

    }

    dropdownOpen(){
        this.isVisible = !this.isVisible;
    }
    closeDropdown(){
        this.isVisible = false;
    }

    rowFunction(rowIndex:number){
        if(this.dropdownValues.items[rowIndex].function != null) this.dropdownValues.items[rowIndex].function();
        if(this.dropdownValues.items[rowIndex].value == "cb") return;         
        this.selectRow(rowIndex);
        this.closeDropdown();
    }
    
    selectRow(rowIndex:number){
        this.selectedRow = rowIndex;
    }

    @Watch('dropdownValues')
    updateSelectedItem(to, from){
        this.findFocus();
    }
}
